module.exports = __webpack_public_path__ + "img/47.b8b0dc27.jpg";